import type { BonusAssessmentSummary } from '@/api/bonificacao-hooks'

export const STATUS_ORDER: Record<string, number> = {
  finalizado: 0,
  validacao_rh: 1,
  em_apuracao: 2,
  rascunho: 3,
}

export function filterAssessments(
  assessments: BonusAssessmentSummary[],
  filters: { department: string; status: string; search: string }
): BonusAssessmentSummary[] {
  return assessments.filter((a) => {
    if (filters.department && a.department !== filters.department) {
      return false
    }
    if (filters.status && a.status !== filters.status) {
      return false
    }
    if (filters.search) {
      const term = filters.search.toLowerCase()
      const nameMatch = a.employeeName.toLowerCase().includes(term)
      const roleMatch = a.role?.toLowerCase().includes(term)
      if (!nameMatch && !roleMatch) return false
    }
    return true
  })
}

export function sortByStatus(assessments: BonusAssessmentSummary[]): BonusAssessmentSummary[] {
  return [...assessments].sort(
    (a, b) => (STATUS_ORDER[a.status] ?? 9) - (STATUS_ORDER[b.status] ?? 9)
  )
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}
